import { Injectable } from '@angular/core';;
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  authToken: string;

  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const excludedUrl = [
      'api/Tokens',
      'api/Password/forgot-password-reset',
      'api/Password/forget-password-update'
    ];

    function containsPartOf(element): boolean {
      return request.url.includes(element);
    }

    if (excludedUrl.some(x => containsPartOf(x))) {
      return next.handle(request);
    }

    // Adds authorization header with JWT if available
    this.authToken = localStorage.getItem('token') || '';
    if (this.authToken) {
      if (this.isJsonString(this.authToken)) {
        this.authToken = JSON.parse(this.authToken);
      }
      else {
        if (this.authenticationService.webAppVersionOneStorageFound()) {
          this.authenticationService.logout(true);
        }
      }

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authToken}`
        }
      });
    } else {
      request = request.clone()
    }

    return next.handle(request);
  }

  private isJsonString(str): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
